import { Box, CircularProgress, Divider, Stack } from "@mui/material";

import { PlanningMode } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.types";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { useTranslation } from "@/translations";

import { AttendanceDayPanel } from "../day-panel/AttendanceDayPanel";
import { PlanningModeSelect } from "../planning-mode-select/PlanningModeSelect";
import { useWeeklySeriesForm } from "./hooks/useWeeklySeriesForm";

type WeeklySeriesFormResult = ReturnType<typeof useWeeklySeriesForm>;

interface Props extends WeeklySeriesFormResult {
  onModeChange: (mode: PlanningMode) => void;
}

export function WeeklySeriesForm({
  formik,
  purposes,
  purposeOptions,
  addEntry,
  removeEntry,
  updateDayEntries,
  isLoading,
  onModeChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Stack spacing={3} width={1200}>
      <Box display="flex" alignItems="flex-start" gap={2} pt={1}>
        <PlanningModeSelect value={PlanningMode.WeeklySeries} onChange={onModeChange} />
        <FormikDatePicker formik={formik} fieldName="dateFrom" label={t("calendar.planAttendance.dateFrom")} required />
        <FormikDatePicker formik={formik} fieldName="dateTo" label={t("calendar.planAttendance.dateTo")} required />
      </Box>
      <Divider />
      <Stack spacing={2}>
        {isLoading && formik.values.days.length === 0 && (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        )}
        {formik.values.days.map((dayValues, dayIndex) => (
          <AttendanceDayPanel
            key={dayIndex}
            formik={formik}
            dayIndex={dayIndex}
            dayValues={dayValues}
            purposeOptions={purposeOptions}
            purposes={purposes}
            onAddEntry={addEntry}
            onRemoveEntry={removeEntry}
            updateDayEntries={updateDayEntries}
            seriesStartDate={formik.values.dateFrom}
          />
        ))}
      </Stack>
    </Stack>
  );
}
